<template>
  <div class="flex justify-between items-center mb-3 " style="min-height:80px">
    <span v-if="showTotal" class="text-2xl font-semibold mr-5">
      {{
        totalEntries > 1 ? `${totalEntries} Au Pairs Found` : `1 Au Pair Found`
      }}
    </span>
    <a
      v-if="checkFilters()"
      @click.prevent="clearFilter()"
      class="btn btn-white cursor-pointer"
    >
      Clear Filters ?
    </a>
  </div>
</template>

<script>
import { defaultFilters } from "@/store";

export default {
  name: "FiltersSummary",
  props: {
    totalEntries: Number,
    filters: Object,
    showTotal: Boolean,
  },
  methods: {
    clearFilter() {
      this.$emit("clear-filters");
    },
    checkFilters() {
      if (this.filters.gender !== defaultFilters.gender) return true;
      if (this.filters.name !== defaultFilters.name) return true;
      if (this.filters.birthCountry !== defaultFilters.birthCountry)
        return true;
      if (this.filters.ageFrom !== defaultFilters.ageFrom) return true;
      if (this.filters.ageTo !== defaultFilters.ageTo) return true;
      if (this.filters.experiencedDriver !== defaultFilters.experiencedDriver)
        return true;
      if (
        this.filters.infantCareQualified !== defaultFilters.infantCareQualified
      )
        return true;
      if (this.filters.swimmer !== defaultFilters.swimmer) return true;
      if (this.filters.gender !== defaultFilters.gender) return true;
      return false;
    },
  },
};
</script>
